import { render, staticRenderFns } from "./PublicOrganigram.vue?vue&type=template&id=5f6277ba&"
import script from "./PublicOrganigram.vue?vue&type=script&lang=js&"
export * from "./PublicOrganigram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports